import React from "react";
import { Stack } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import SafeView from "@/components/safeView";
const Certificates = dynamic(() => import("@/components/certificates"));
const ContactForm = dynamic(() => import("@/components/contactForm"));
const Customers = dynamic(() => import("@/components/ourCustomers"));
const TechPartners = dynamic(() => import("@/components/technologyPartners"));
const Features = dynamic(() => import("@/components/features"));

type Props = {
  children: React.ReactNode;
  marginTop?: number;
  showCertificates?: boolean;
  showContactForm?: boolean;
  showCustomers?: boolean;
  showTechPartners?: boolean;
  showFeatures?: boolean;
  spacing?: number;
};

const PageLayout = (props: Props) => {
  const {
    children,
    marginTop = 12,
    showCertificates,
    showContactForm,
    showCustomers,
    showTechPartners,
    showFeatures,
    spacing = 20,
  } = props;
  return (
    <SafeView>
      <Stack marginTop={marginTop} spacing={spacing}>
        {children}
        {showCertificates && <Certificates />}
        {showCustomers && <Customers />}
        {showFeatures && <Features />}
        {showTechPartners && <TechPartners />}
        {showContactForm && <ContactForm />}
      </Stack>
    </SafeView>
  );
};

export default PageLayout;
